import React from "react";
import { Badge } from "@/components/ui/badge";
import { User } from "lucide-react";

interface GibNiftyBadgeProps {
  className?: string;
}

const GibNiftyBadge: React.FC<GibNiftyBadgeProps> = ({ className = "" }) => {
  return (
    <Badge 
      className={`bg-gradient-to-r from-violet-500 via-purple-400 to-violet-600 text-white border-violet-700 font-semibold shadow-sm ${className}`}
    >
      <User className="h-3 w-3 mr-1" />
      GibNifty
    </Badge>
  );
};

export default GibNiftyBadge;
